// MenuScene — title screen. After create() finishes, calls
// TestSeam.markReady() so Playwright can wait on `__TEST__.ready === true`
// (the established anti-flake gate).

import Phaser from 'phaser';
import { TestSeam } from '../debug/TestSeam';

export class MenuScene extends Phaser.Scene {
  constructor() {
    super('MenuScene');
  }

  create(): void {
    TestSeam.setScene('MenuScene');

    const cx = this.cameras.main.width / 2;
    const cy = this.cameras.main.height / 2;

    this.add
      .text(cx, cy - 12, 'DEGEN KONG', {
        fontFamily: 'monospace',
        fontSize: '24px',
        color: '#f5c542',
      })
      .setOrigin(0.5);

    this.add
      .text(cx, cy + 16, 'press ENTER to cash out', {
        fontFamily: 'monospace',
        fontSize: '10px',
        color: '#f5e1c8',
      })
      .setOrigin(0.5);

    this.input.keyboard?.on('keydown-ENTER', () => this.scene.start('RunScene', { floor: 0 }));
    this.input.keyboard?.on('keydown-SPACE', () => this.scene.start('RunScene', { floor: 0 }));

    TestSeam.markReady();
  }
}
